import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '400px',
    padding: '40px 20px',
    margin: '40px auto',
    maxWidth: '800px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  },
  title: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 600,
    color: '#333',
    marginBottom: '16px',
    textAlign: 'center',
    [theme.breakpoints.down(660)]: {
      fontSize: theme.typography.pxToRem(20),
    },
  },
  message: {
    fontSize: theme.typography.pxToRem(16),
    color: '#666',
    textAlign: 'center',
    maxWidth: '600px',
  },
}))
